module.exports = __webpack_public_path__ + "img/DJI_0024.8cc5d108.jpg";